import { Store } from 'redux';

import { getInitialSearchLocation } from 'algolia-api/search/getInitialSearchLocation';
import { ApiUserEnvironment } from 'api/userEnvironment/types/ApiUserEnvironment';
import { MainStoreState } from 'modules/main/store/MainStoreState';
import { updateSearchLocation } from 'modules/main/store/ducks/mainSearch';
import { updateUserEnvironment } from 'modules/main/store/ducks/userEnvironment';
import { configureAnalyticsUserData } from 'utils/analytics/setup/configureAnalyticsUserData';
import { registerAbExperiments } from 'utils/analytics/setup/registerAbExperiments';
import { configureTrackJs } from 'utils/configureTrackJs';
import { trackReferrals } from 'utils/trackReferral';

import { ssrClientOverrideABExperiments } from './ssrClientOverrideABExperiments';
import { ssrClientPerformanceMark } from './ssrClientPerformanceMark';

type Args = {
  store: Store<MainStoreState>;
  userEnvironment: ApiUserEnvironment;
};

export function onSsrClientUserEnvironmentLoaded({
  store,
  userEnvironment,
}: Args) {
  store.dispatch(updateUserEnvironment(userEnvironment));

  const { searchLocation } = store.getState().mainSearch;

  if (!searchLocation) {
    store.dispatch(
      // @ts-expect-error fix types
      updateSearchLocation(
        getInitialSearchLocation(userEnvironment.environment.guessedLocation),
        false,
      ),
    );
  }

  ssrClientPerformanceMark('Done setting login state');

  // Tracking
  configureTrackJs(userEnvironment.user ? userEnvironment.user.id : null);
  configureAnalyticsUserData({ userEnvironment });
  trackReferrals();

  // Configure AB experiments
  store.subscribe(() => {
    registerAbExperiments(
      store.getState().userEnvironment?.environment?.abExperiments,
    );
  });

  ssrClientOverrideABExperiments(store, userEnvironment);
  ssrClientPerformanceMark('User data first load');
}
